import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { getHealthInfo } from '../api/health.api';
import { getHumanizedDiskUsage } from '../utils/common.utils';

import { DiskUsageInfo } from '../components/DiskUsage/DiskUsageInfo.view';

import type { HealthInfoResponse } from '../types/health.types';
import type { RootState } from '../types/state.types';

export const DiskUsageInfoContainer: React.FC = () => {
  const [diskUsage, setDiskUsage] = useState<HealthInfoResponse>();
  const { defaultConnectionUrl, connected, connecting } = useSelector(
    (state: RootState) => state.subscription
  );

  useEffect(() => {
    let isMounted = true;

    const fetchHealthInfo = async () => {
      if (connected && isMounted) {
        try {
          const healthInfo = await getHealthInfo(defaultConnectionUrl);

          setDiskUsage(healthInfo);
        } catch (error) {
          console.error(error);
        }
      }
    };

    fetchHealthInfo();

    return () => {
      isMounted = false;
    };
  }, [connected, defaultConnectionUrl]);

  const diskUsageValue = getHumanizedDiskUsage(diskUsage?.store_disk_usage ?? 0);

  return (
    <DiskUsageInfo connected={connected} connecting={connecting} diskUsageValue={diskUsageValue} />
  );
};
